<template>
  <div>
    <Row  class="page">
      <Page
        class="p_s"
        show-elevator
        show-sizer
        show-total
        size="small"
        :current="pageNumber"
        :total="total"
        :page-size="pageSize"
        :page-size-opts="pageSizeOpts"
        @on-change="changePageNumber"
        @on-page-size-change="changePageSize"
      >
      </Page>
    </Row>
  </div>
</template>
<script>
export default {
  name: 'page',
  data() {
    return {}
  },
  props: ['pageNumber', 'pageSize', 'pageSizeOpts', 'total'],
  methods: {
    changePageNumber(v) {
      this.$emit('changePageNumber', v)
    },
    changePageSize(v) {
      this.$emit('changePageSize', v)
    }
  }
}
</script>
<style scoped>
/*.p_s{*/
/*margin: 10px;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/views/teacher/components/page.vue